import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\RefreshQuotePricesController::__invoke
* @see app/Http/Controllers/Invoice/RefreshQuotePricesController.php
* @route '/api/invoicing/{invoice}/refresh-prices'
*/
const RefreshQuotePricesController = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: RefreshQuotePricesController.url(args, options),
    method: 'put',
})

RefreshQuotePricesController.definition = {
    methods: ["put"],
    url: '/api/invoicing/{invoice}/refresh-prices',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Invoice\RefreshQuotePricesController::__invoke
* @see app/Http/Controllers/Invoice/RefreshQuotePricesController.php
* @route '/api/invoicing/{invoice}/refresh-prices'
*/
RefreshQuotePricesController.url = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoice: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoice: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
    }

    return RefreshQuotePricesController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\RefreshQuotePricesController::__invoke
* @see app/Http/Controllers/Invoice/RefreshQuotePricesController.php
* @route '/api/invoicing/{invoice}/refresh-prices'
*/
RefreshQuotePricesController.put = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: RefreshQuotePricesController.url(args, options),
    method: 'put',
})

export default RefreshQuotePricesController